export const API_URL_PROD = 'https://sia.gruposi.com.br';
export const API_URL_HOMO = 'http://gruposi.com.br:3005';
export const API_URL_LOCAL = 'http://localhost:3005';

export const API_URL = API_URL_PROD;

//export const API_URL = API_URL_LOCAL;

// export const API_URL = API_URL_HOMO;


// as funções abaixo foram usadas apenas no login

export function TOKEN_POST(body) {
  return {
    url: API_URL + '/user/login',
    options: {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    },
  };
} // ajustado

export function TOKEN_VALIDATE_POST(token) {
  return {
    url: API_URL + '/verifytoken',
    options: {
      method: 'GET',
      mode: 'no-cors',
      headers: {
        Authorization: 'Bearer ' + token,
      },
    },
  };
}

export function ALL_USER_GET() {
  return {
    url: API_URL + '/client',
    options: {
      method: 'GET',
    },
  };
}

export function USER_GET(token, id) {
  return {
    url: `${API_URL}/user/id/${id}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token,
      },
    },
  };
}

export function USER_POST(body) {
  return {
    url: API_URL + '/api/user',
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    },
  };
}

export function ATENDIMENTO_GET() {
  return {
    method: 'get',
    url: API_URL + '/atend/2023-01-01/2023-01-31',
  };
}

export function STATS_GET() {
  return {
    url: API_URL + '/api/stats',
    options: {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + window.localStorage.getItem('token'),
      },
    },
  };
}

export function LOGS_DASHBOARD_GET(dias = 90) {
  return {
    method: 'get',
    url: API_URL + `/log/dashboard?dias=${dias}`,
  };
}

export function LOGS_LISTA_GET(datestart, dateend, page = 1, limit = 50, search = '', tipo = 'acesso', excluirNunca = false) {
  let url = API_URL + `/log/lista?page=${page}&limit=${limit}&tipo=${tipo}`;
  if (datestart && dateend) {
    url += `&datestart=${datestart}&dateend=${dateend}`;
  }
  if (search) {
    url += `&search=${search}`;
  }
  if (excluirNunca) {
    url += `&excluirNunca=true`;
  }
  return {
    method: 'get',
    url: url,
  };
}

// ---- Notificações ----

export function NOTIFICACOES_ATIVAS_GET() {
  return {
    method: 'get',
    url: API_URL + '/notificacoes/ativas',
  };
}

export function NOTIFICACOES_ALL_GET() {
  return {
    method: 'get',
    url: API_URL + '/notificacoes/',
  };
}

export function CLIENT_SEARCH_GET(search) {
  return {
    method: 'get',
    url: API_URL + `/client/search/${search}`,
  };
}